import { createAsyncThunk } from '@reduxjs/toolkit';
import { MARKETING_CONFIG_KEY, PERSONAL_DATA_CONSULTANT_CALLBACK_CONFIG_KEY } from '../../constants/links';
import { EStatus } from '../../repositories/users-features/entities/add_legal_agreement/PublicAddLegalAgreementV1Request';
import type { TAddLegalAgreementRequest } from '../../repositories/users-features/v1/add-legal-agreement';
import { resolveAddLegalAgreementBatched } from '../../services/addLegalAgreement';
import { IThunkApi } from '../../types/redux';

export interface IAgreementConfig {
  agreementType: string;
  agreement: string;
  agreementVersion: number;
  source: string;
}

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

const mapAgreementToRequest = (
  accepted: boolean,
  { agreementType, agreementVersion, source }: IAgreementConfig,
): TAddLegalAgreementRequest => ({
  agreementType,
  agreementVersion,
  status: EStatus.Accepted,
  source,
});

export const sendLegalAgreements = createAsyncThunk<void, void, IThunkApiExtended>(
  'legalAgreement/sendLegalAgreements',
  async (_, { getState, extra: context }) => {
    const state = getState();
    const { marketingAgreement, personalData } = state.agreements;

    const marketingConfig = context.config.getStrict<IAgreementConfig>(MARKETING_CONFIG_KEY);
    const personalDataConfig = context.config.getStrict<IAgreementConfig>(PERSONAL_DATA_CONSULTANT_CALLBACK_CONFIG_KEY);

    const parametersList: TAddLegalAgreementRequest[] = [
      ...(marketingAgreement ? [mapAgreementToRequest(marketingAgreement, marketingConfig)] : []),
      mapAgreementToRequest(personalData, personalDataConfig),
    ];

    await resolveAddLegalAgreementBatched(context, parametersList);
  },
);
